<template>
  <!--begin::User-->
  <div @click="showSignIn" class="user-menu mb-5">
    <div
      class="cursor-pointer d-flex align-items-center symbol symbol-30px symbol-md-40px"
    >
      <div class="symbol symbol-size">
        <h1 class="symbol-label symbol-name">-</h1>
      </div>
      <div class="menu-content d-flex align-items-center px-3">
        <!-- begin::Username-->
        <div class="d-flex flex-column">
          <div class="current-name d-flex align-items-center fs-5">
            Not signed in
          </div>
        </div>
        <!--end::Username -->
      </div>
    </div>
  </div>
  <!--end::Toolbar wrapper-->
</template>

<script>
export default {
  name: "guest-menu",
  methods: {
    showSignIn() {
      this.$router.push({ name: "sign-in" });
    },
  },
};
</script>

<style lang="scss" scoped>
.user-menu {
  border-bottom: 1px solid #e7edf7;
  padding-bottom: 7px;
  padding-top: 7px;
  padding-left: 24px;
  font-family: Poppins, Helvetica, "sans-serif" !important;
}
.symbol-label {
  background: #334f7c;
  color: #fff;
  border-radius: 50%;
  width: 34px !important;
  height: 34px !important;
  margin-bottom: 0px;
  font-size: 14px;
}
.current-name {
  color: #334f7c;
  font-size: 14px;
  font-weight: 500;
  text-transform: capitalize;
}
</style>
